// extracted by mini-css-extract-plugin
export default {"authContainer":"Auth_authContainer__eBuA1"};